export enum eDrivingColors {
  blue = '#008ed3',
  green = '#69ad25',
  yellow = '#f1c40f',
  red = '#de2828',
}

export enum CellColors {
  red = 'agGridRedTexts',
  green = 'agGridGreenTexts',
  orange = 'agGridAmberTexts',
  amber = 'agGridAmberTexts',
  black = 'agGridBlackTexts',
  blue = 'agGridBlueTexts',
  grey = 'agGridGreyTexts',
  'red-cell' = 'sev-red',
  'amber-cell' = 'sev-amber',
}

export enum SidePaneColors {
  red = 'red',
  orange = 'orange',
  green = 'green',
  blue = 'blue',
  black = 'black',
  grey = 'grey',
}
